module.exports = "<div class=\"modal-dialog align-center\" [ngClass]=\"{ 'modal-sm': isSmall(), 'modal-lg': isLarge() }\">\r\n    <div class=\"modal-content\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./app/shared/modeldialog/template/modal.Template.html
// module id = 605
// module chunks = 3